module.exports = "https://cdn.betha.cloud/base/g4/design/3.12.3/assets/images/avatar.png";